<div [class.tab-item-content-container]="useDefaultHeight">
  <div [hidden]="!showContent">
    <ng-container *ngComponentOutlet="tab?.componentType" />
  </div>
</div>
